<template>
  <div style="padding: 1rem 3rem;">
    <p class="title is-3-desktop is-4-tablet is-5-mobile">
      Nuevo Pedido Cajas/Materiales
    </p>
    <p class="title" style="font-size: 1.2rem;">Solicitud de cajas/materiales vacías</p>

    <section style="text-align: center;">

      <div class="block">
        <b-radio v-model="radioStatus" native-value="all"> Todos los estados</b-radio>
        <b-radio v-model="radioStatus" native-value="pen"> Pendientes</b-radio>
        <b-radio v-model="radioStatus" native-value="recep"> Recepcionado</b-radio>
        <b-radio v-model="radioStatus" native-value="env"> Enviados</b-radio>
        <b-radio v-model="radioStatus" native-value="can"> Cancelados</b-radio>
      </div>

      <div class="block">
        <a @click="showModalCrearPedido" class="button is-success">Nueva Solicitud</a>
        <a @click="cargarPedidos" class="button is-info">Consultar</a>
      </div>
    </section>

    <section style="margin-top: 30px">
      <b-table :data="pedidoList" :hoverable="true" :mobile-cards="true" :opened-detailed="defaultOpenedDetails"
               detail-key="id" paginated backend-pagination :total="total" :per-page="searchOptions.perPage"
               :default-sort-direction="defaultSortOrder"
               :default-sort="[searchOptions.sortField, searchOptions.sortOrder]">

        <template slot-scope="props">
          <b-table-column label="Usuario" class="is-size-7">
            {{ props.row.userName }}
          </b-table-column>
          <b-table-column label="Dirección" class="is-size-7">
            {{ props.row.address.description }}
          </b-table-column>
          <b-table-column label="Total Cajas" class="is-size-7 has-text-centered">
            {{ props.row.total }}
          </b-table-column>
          <b-table-column label="Nro Orden" class="is-size-7">
            {{ props.row.numberOrder }}
          </b-table-column>
          <b-table-column field="orderDate" label="Fecha Solicitud" class="is-size-7">
            {{ new Date(props.row.orderDate) | moment("DD-MM-YYYY - h:mm a") }}
          </b-table-column>
          <b-table-column field="deliveryDate" label="Fecha Entrega" class="is-size-7">
            {{ new Date(props.row.deliveryDate) | moment("DD-MM-YYYY - h:mm a") }}
          </b-table-column>
          <b-table-column label="Estado" class="is-size-7">
            <b-tag :type="getClassStatusOrder(props.row.status)">{{ props.row.status | StatusOrderConvert }}</b-tag>
          </b-table-column>
          <b-table-column label="Acciones" centered>
            <b-tooltip type="is-dark" label="Cancelar pedido" position="is-left">
              <button :disabled="isCancelable(props.row)" @click="doCancelOrderGeneral(props.row)"
                      class="button is-small">
                <b-icon type="is-danger" size="is-mediun" icon="cancel"></b-icon>
              </button>
            </b-tooltip>
            <b-tooltip v-if="props.row.status!=='pen' && props.row.status!=='can'" type="is-dark" label="Ver detalle"
                       position="is-left">
              <button @click="showModalDetails(props.row)" class="button is-small">
                <b-icon type="is-info" size="is-mediun" icon="cards-variant"></b-icon>
              </button>
            </b-tooltip>
            <!-- <b-tooltip v-if="props.row.status=='recep'" type="is-dark" label="Registro de contenido" position="is-left">
              <button @click="showModalDetails(props.row)" class="button is-small">
                <b-icon type="is-info" size="is-mediun" icon="archive"></b-icon>
              </button>
            </b-tooltip> -->
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large"></b-icon>
              </p>
              <p>Ninguna Solicitud Registrada.</p>
            </div>
          </section>
        </template>

      </b-table>
    </section>

  </div>
</template>

<script>

import {mapGetters, mapActions} from "vuex";
import Util from '../../util'

const CrearPedido = () => import("../../components/modal/RegistrarPedido");
const DetailsPedido = () => import("../../components/pedido/Details");

export default {
  props: ["address"],

  data() {
    return {
      pedidoList: [],
      defaultOpenedDetails: [1],
      total: 0,
      searchOptions: {perPage: 10, pageNumber: 1, sortField: 'orderDate', sortOrder: 'desc'},
      defaultSortOrder: 'desc',
      radioStatus: "all"
    };
  },
  methods: {
    ...mapActions({
      'loadOrderGeneral': 'orderGeneral/loadOrderGeneral',
      'changeOrderGeneral': 'orderGeneral/changeOrderGeneral',
    }),

    showModalCrearPedido() {
      this.$modal.open({
        parent: this,
        component: CrearPedido,
        hasModalCard: true,
        props: {
          cargarPedidos: this.cargarPedidos,
          address: this.getAddress,
          businessHours: Util.getClient().businessHours
        }
      });
    },

    showModalDetails(data) {
      this.$modal.open({
        parent: this,
        component: DetailsPedido,
        hasModalCard: true,
        props: {
          order: data,
          cargarPedidos: this.cargarPedidos,
        }
      });
    },

    cargarPedidos() {
      let payload = null
      payload = {context: this, idClient: Util.getAuth().idClient}
      this.loadOrderGeneral(payload).then(data => {
        if (this.radioStatus === 'all') {
          this.pedidoList = data
        } else {
          this.pedidoList = data.filter(item => item.status === this.radioStatus);
        }
        this.total = this.pedidoList.length;
      }).catch((error) => {
        this.pedidoList = []
        this.total = 0
      })
    },

    getClassStatusOrder(value) {
      if (!value) return ''
      if (value === 'pen')
        return 'is-warning'
      else if (value === 'env' || value === 'ent')
        return 'is-info'
      else if (value === "recep")
        return 'is-success'
      else if (value === 'can')
        return 'is-danger'
      else return ''
    },

    doCancelOrderGeneral(order) {
      this.$dialog.confirm({
        title: 'Cancelar pedido',
        message: '¿Está seguro que desea <b>cancelar</b> el pedido?',
        confirmText: 'Si',
        cancelText: 'No',
        type: 'is-warning',
        hasIcon: true,
        onConfirm: () => {
          this.goCancelOrderGeneral(order)
        }
      })
    },

    goCancelOrderGeneral(order) {
      this.changeOrderGeneral({context: this, idOrder: order.id, type: "cancel"}).then(() => {
        this.cargarPedidos();
        this.$toast.open(`La orden   ${order.numberOrder} ha sido cancelada.`);
      }).catch((error) => {
        console.error(error);
      })
    },

    isCancelable(order) {
      return order.status !== 'pen'
    },
  },

  computed: {
    ...mapGetters({
      getClient: "auth/getClient",
    }),

    getAddress() {
      return this.client.addresses[0];
    },
  },

  filters: {
    OrderGeneralType: function (type) {
      if (type === 'BOX') return 'Cajas'
      if (type === 'BOX_MEDIOS') return 'Caja Medios'
      if (type === 'BOX_PLANOS') return 'Caja Planos'
      if (type === 'BOX_MUESTRAS') return 'Caja Muestras'
      return 'Error'
    },
  },

  mounted() {
    this.cargarPedidos();
    this.client = Util.getClient();
  },

  created() {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pedido/MainPedido.vue